/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MarqCommonProtocolEmptyResponse,
  MonitoringFilterProtocolResponse,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsApplyCustomTagRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsDeleteAllCustomTagRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCommentUserTypeFilterRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCountRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCountResponse,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCountryFilterRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCustomTagsFilterRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetDomainFilterRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetExportListingsRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetExportListingsResponse,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetTpProgressFilterRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteDetailRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteDetailResponse,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteListRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteListResponse,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsRequestAuthorizedRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsRequestAuthorizedResponse,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsRequestTestPurchaseRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsRequestTestPurchaseResponse,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsUpdateWebsiteStatusByTabRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsUpdateWebsiteStatusByTabResponse,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsUpdateWebsiteStatusRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsUpdateWebsiteStatusResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class MonitoringWebsiteContents<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags MonitoringWebsiteContents
   * @name ContentsFilterDomainCreate
   * @request POST:/website/contents/filter/domain
   */
  contentsFilterDomainCreate = (
    data: MonitoringWebsiteContentWebsiteContentCommonProtocolsGetDomainFilterRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/website/contents/filter/domain`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteContents
   * @name ContentsFilterCustomTagsCreate
   * @request POST:/website/contents/filter/custom-tags
   */
  contentsFilterCustomTagsCreate = (
    data: MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCustomTagsFilterRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/website/contents/filter/custom-tags`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteContents
   * @name ContentsFilterCountryCreate
   * @request POST:/website/contents/filter/country
   */
  contentsFilterCountryCreate = (
    data: MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCountryFilterRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/website/contents/filter/country`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteContents
   * @name ContentsFilterCommentUserTypeCreate
   * @request POST:/website/contents/filter/comment-user-type
   */
  contentsFilterCommentUserTypeCreate = (
    data: MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCommentUserTypeFilterRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/website/contents/filter/comment-user-type`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteContents
   * @name ContentsCountCreate
   * @request POST:/website/contents/count
   */
  contentsCountCreate = (
    data: MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCountRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCountResponse, any>({
      path: `/website/contents/count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteContents
   * @name ContentsProgressFilterCreate
   * @request POST:/website/contents/progress_filter
   */
  contentsProgressFilterCreate = (
    data: MonitoringWebsiteContentWebsiteContentCommonProtocolsGetTpProgressFilterRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/website/contents/progress_filter`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteContents
   * @name ContentsGetListCreate
   * @request POST:/website/contents/get-list
   */
  contentsGetListCreate = (
    data: MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteListRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteListResponse, any>({
      path: `/website/contents/get-list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteContents
   * @name ContentsDetailsCreate
   * @request POST:/website/contents/details
   */
  contentsDetailsCreate = (
    data: MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteDetailRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteDetailResponse, any>({
      path: `/website/contents/details`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteContents
   * @name ContentsExcelCreate
   * @request POST:/website/contents/excel
   */
  contentsExcelCreate = (
    data: MonitoringWebsiteContentWebsiteContentCommonProtocolsGetExportListingsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteContentWebsiteContentCommonProtocolsGetExportListingsResponse, any>({
      path: `/website/contents/excel`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteContents
   * @name ContentsStatusUpdateCreate
   * @request POST:/website/contents/status/update
   */
  contentsStatusUpdateCreate = (
    data: MonitoringWebsiteContentWebsiteContentCommonProtocolsUpdateWebsiteStatusRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteContentWebsiteContentCommonProtocolsUpdateWebsiteStatusResponse, any>({
      path: `/website/contents/status/update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteContents
   * @name ContentsStatusTabUpdateCreate
   * @request POST:/website/contents/status/tab/update
   */
  contentsStatusTabUpdateCreate = (
    data: MonitoringWebsiteContentWebsiteContentCommonProtocolsUpdateWebsiteStatusByTabRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteContentWebsiteContentCommonProtocolsUpdateWebsiteStatusByTabResponse, any>({
      path: `/website/contents/status/tab/update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteContents
   * @name ContentsAuthorizedCreate
   * @request POST:/website/contents/authorized
   */
  contentsAuthorizedCreate = (
    data: MonitoringWebsiteContentWebsiteContentCommonProtocolsRequestAuthorizedRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteContentWebsiteContentCommonProtocolsRequestAuthorizedResponse, any>({
      path: `/website/contents/authorized`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteContents
   * @name ContentsTpCreate
   * @request POST:/website/contents/tp
   */
  contentsTpCreate = (
    data: MonitoringWebsiteContentWebsiteContentCommonProtocolsRequestTestPurchaseRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteContentWebsiteContentCommonProtocolsRequestTestPurchaseResponse, any>({
      path: `/website/contents/tp`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteContents
   * @name ContentsCustomTagApplyCreate
   * @request POST:/website/contents/custom-tag/apply
   */
  contentsCustomTagApplyCreate = (
    data: MonitoringWebsiteContentWebsiteContentCommonProtocolsApplyCustomTagRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/website/contents/custom-tag/apply`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteContents
   * @name ContentsCustomTagDeleteAllCreate
   * @request POST:/website/contents/custom-tag/delete-all
   */
  contentsCustomTagDeleteAllCreate = (
    data: MonitoringWebsiteContentWebsiteContentCommonProtocolsDeleteAllCustomTagRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/website/contents/custom-tag/delete-all`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
